module.exports = __webpack_public_path__ + "media/images/static/merits/merit_01-ab43d15ef282de70e52e01c23ba26fcd.png";